export default function (Component) {
  Component.__i18n = Component.__i18n || []
  Component.__i18n.push({
    "locale": "",
    "resource": {
      "en": {
        "CDA": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["CDA"])},
        "CDA_PREFILLED_NAME": (ctx) => {const { normalize: _normalize, interpolate: _interpolate, named: _named } = ctx;return _normalize(["CDA with ", _interpolate(_named("company"))])},
        "AGREEMENT_CREATION_STEP": {
          "MANDATORY": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Additional required information"])}
        },
        "STEP_COUNT": (ctx) => {const { normalize: _normalize, interpolate: _interpolate, named: _named } = ctx;return _normalize(["Step ", _interpolate(_named("currentStep")), "/", _interpolate(_named("nbSteps"))])},
        "NAME": {
          "LABEL": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Name"])},
          "PLACEHOLDER": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Enter name"])},
          "ERROR": {
            "LONG": (ctx) => {const { normalize: _normalize, interpolate: _interpolate, named: _named } = ctx;return _normalize(["Name is too long. ", _interpolate(_named("x")), " characters are allowed"])}
          }
        },
        "TYPE": {
          "LABEL": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Type"])}
        },
        "COMPANIES": {
          "LABEL": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Partners"])}
        },
        "STATUS": {
          "LABEL": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Status"])}
        },
        "EFFECTIVE_DATE": {
          "LABEL": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Effective date"])}
        },
        "EXPIRATION_DATE": {
          "LABEL": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Expiration date"])},
          "DURATION": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Duration"])},
          "DATE_PERIOD": (ctx) => {const { normalize: _normalize, interpolate: _interpolate, named: _named, plural: _plural } = ctx;return _plural([_normalize([_interpolate(_named("count")), " year"]), _normalize([_interpolate(_named("count")), " years"])])}
        },
        "DEFINITION": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Definition"])},
        "VALIDITY": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Validity"])},
        "DOCUMENT": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Document"])},
        "RESULT_STATUS": {
          "SINGLE_ACTIVE_AGREEMENT": (ctx) => {const { normalize: _normalize, linked: _linked, type: _type, interpolate: _interpolate, named: _named } = ctx;return _normalize(["We found one active ", _linked("MASTER_OBJECT.LOW", undefined, _type), "  ", _linked("AGREEMENT.LOW.SING", undefined, _type), " with ", _interpolate(_named("companies"))])},
          "MULTIPLE_ACTIVE_AGREEMENTS": (ctx) => {const { normalize: _normalize, interpolate: _interpolate, named: _named, linked: _linked, type: _type } = ctx;return _normalize(["We found ", _interpolate(_named("msa")), " active ", _linked("MASTER_OBJECT.LOW", undefined, _type), "  ", _linked("AGREEMENT.LOW.PLUR", undefined, _type), " with ", _interpolate(_named("companies"))])}
        },
        "NONE": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["None"])},
        "CUSTOM": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Custom"])},
        "LINK_MASTER_AGREEMENTS": (ctx) => {const { normalize: _normalize, linked: _linked, type: _type } = ctx;return _normalize([_linked("LINK.CAP.SING", undefined, _type), " to all master ", _linked("AGREEMENT.LOW.PLUR", undefined, _type)])}
      }
    }
  })
}
